<section id="home" class="hero-section">
  <div class="container">
    <div class="row justify-content-center align-items-center min-vh-100">
      <div class="col-lg-8 text-center">
        <div class="hero-content">
          <h1 class="display-4 fw-bold mb-4 fade-in-up">
            {{ getTranslation('hero.title') }}
          </h1>
          <p class="lead mb-5 fade-in-up fade-in-up-delay-1">
            {{ getTranslation('hero.subtitle') }}
          </p>
          <div class="hero-buttons fade-in-up fade-in-up-delay-2">
            <button
              class="btn btn-gradient btn-lg me-3 mb-3"
              (click)="scrollToSection('contact')">
              {{ getTranslation('hero.cta') }}
              <i class="fas fa-arrow-right ms-2"></i>
            </button>
            <button
              class="btn btn-outline-light btn-lg mb-3"
              (click)="scrollToSection('about')">
              <i class="fas fa-user me-2"></i>
              {{ getTranslation('nav.about') }}
            </button>
          </div>

          <!-- Social links -->
          <div class="social-links mt-5 fade-in-up fade-in-up-delay-3">
            <a href="https://github.com/stradetskyi" class="text-white me-4" title="GitHub">
              <i class="fab fa-github fa-2x"></i>
            </a>
            <a href="https://www.linkedin.com/in/oleksandr-stradetskyi/" class="text-white me-4" title="LinkedIn">
              <i class="fab fa-linkedin fa-2x"></i>
            </a>
             <a href="https://t.me/stradetskyi" class="text-white me-4" title="Telegram">
              <i class="fab fa-telegram fa-2x"></i>
            </a>
            <a href="mailto:stradetskyi&#64;gmail.com" class="text-white" title="Email">
              <i class="fas fa-envelope fa-2x"></i>
            </a>
          </div>
        </div>
      </div>
    </div>

    <!-- Scroll indicator -->
    <div class="scroll-indicator text-center">
      <button
        class="btn btn-link text-white p-0"
        (click)="scrollToSection('about')"
        title="Scroll down">
        <i class="fas fa-chevron-down fa-2x animate-bounce"></i>
      </button>
    </div>
  </div>
</section>
